import { Component, OnInit, Input, Output, EventEmitter, ViewChild, AfterViewInit } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { FileInfo } from 'sg-api';

/**
 * ファイル情報表示
 * @export
 * @class FileDownloadResultComponent
 * @implements {OnInit, AfterViewInit}
 */
@Component({
  selector: 'app-file-download-result',
  templateUrl: './sgkd017d-download-result.component.html',
  styleUrls: ['./sgkd017d-download-result.component.scss'],
})
export class Sgkd017dDownloadResultComponent implements OnInit, AfterViewInit {
  /** SZZA016Aで取得したファイル情報 */
  @Input() responseList: Array<FileInfo> | null = null;
  /** 行クリックイベント */
  @Output() rowClickEvent = new EventEmitter<FileInfo>();

  /** ページネーションオブジェクト */
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  /** ソートオブジェクト */
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  /** 検索結果表示データソース */
  dataSource: MatTableDataSource<FileInfo>;

  /** テーブル表示情報 */
  displayedColumns: string[] = [
    'fileName',
    'fileSize',
    'lastUpdateDate',
  ];

  /**
   * コンストラクタ
   * @memberof SearchCustomerComponent
   */
  constructor() { }

  /**
   * 初期処理
   * @memberof SearchCustomerComponent
   */
  ngOnInit(): void {
    this.createDataSource();
  }

  /**
   * テーブルデータソース作成
   */
  private createDataSource(): void {
    if (this.responseList != null && this.responseList.length != 0) {
      // Table表示データ作成
      this.dataSource = new MatTableDataSource(this.responseList);
    }
  }

  /**
   * ViewInit後の呼び出し
   */
  ngAfterViewInit() {
    // NOTE:Angular7以降？paginator要素が"*ngIf"で囲まれていると、下記の初期化の際にundefinedとなってしまう。
    // 参考：https://stackoverflow.com/questions/48785965/angular-matpaginator-not-working/55021197
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  /**
   * 検索結果のフィルタ処理
   * 入力した文字が行内に含まれている場合、表示対象となる。
   * ※特定のセルではなく、行全体
   * @param event 
   */
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  /**
   * 行選択処理
   * @param event 
   */
  onClickRow(row: FileInfo): void {
    console.log(row);
    this.rowClickEvent.emit(row);
  }
}
